<template>
    <b-modal id="calculationInformationModal" :title="dialogTitle" v-if="salaryRow" size="lg" ok-only>
        <component v-bind:is="salaryRow.calculation" :calculationData="calculationData"/>
    </b-modal>
</template>

<script>
import { salarySpecificationService } from "../../../shared/services";
import PersonalExpensesCalculation from "./calculationInformation/PersonalExpensesCalculation"
import ParentalLeaveCalculation from "./calculationInformation/ParentalLeaveCalculation"
import CompensatoryTimeCalculation from "./calculationInformation/CompensatoryTimeCalculation"
import VacationCalculation from "./calculationInformation/VacationCalculation"
import CongestionTaxCalculation from "./calculationInformation/CongestionTaxCalculation"
import GrossSalaryDeductionForPersonalExpensesCalculation from "./calculationInformation/GrossSalaryDeductionForPersonalExpensesCalculation"
import BenefitVehicleInvoiceCalculation from "./calculationInformation/BenefitVehicleInvoiceCalculation"
import GrossSalaryDeductionForInvoiceExpensesCalculation from "./calculationInformation/GrossSalaryDeductionForInvoiceExpensesCalculation"
import CareOfChildCalculation from "./calculationInformation/CareOfChildCalculation"
import VariableSalaryByChargeabilityCalculation from "./calculationInformation/VariableSalaryByChargeabilityCalculation"
import SickLeaveWithQualifyingDeductionCalculation from "./calculationInformation/SickLeaveWithQualifyingDeductionCalculation"


export default {
    components: {
        PersonalExpensesCalculation,
        ParentalLeaveCalculation,
        CompensatoryTimeCalculation,
        VacationCalculation,
        CongestionTaxCalculation,
        GrossSalaryDeductionForPersonalExpensesCalculation,
        BenefitVehicleInvoiceCalculation,
        GrossSalaryDeductionForInvoiceExpensesCalculation,
        CareOfChildCalculation,
        VariableSalaryByChargeabilityCalculation,
        SickLeaveWithQualifyingDeductionCalculation
        
    },
    computed: {
        dialogTitle() {
            if(this.title) return this.title;
            return this.salaryRow.definition;
        }
    },
    data() {
        return {
            calculationData: null,
            salaryRow: null,
            title: null
        };
    },     
    methods: {
        show(salaryRow) {
            this.salaryRow = salaryRow;
            salarySpecificationService.getCalculationData(salaryRow.id).then(p => {
                this.calculationData = p;
                this.$bvModal.show('calculationInformationModal');
            }).catch(() => {
                this.ShowToast("Fel", "Ett okänt fel uppstod när uträkningsdata skulle hämtas", "danger");
            })
        }
    }

}
</script>

<style>

</style>
